import { styled, Typography } from '@mui/material';
import { motion } from 'framer-motion';

export const AppPromo = styled('section')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  gap: '20px',
  width: '100%',

  [theme.breakpoints.down('lg')]: {
    flexWrap: 'wrap',
  },
  [theme.breakpoints.down('md')]: {
    gap: '12px',
  },
}));

export const Card = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: '44px',
  borderRadius: '24px',
  backgroundColor: theme.palette.color.global.card,
  overflow: 'hidden',

  '&:first-of-type': {
    flex: '1 1 auto',
  },
  '&:last-of-type': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '708px',

    [theme.breakpoints.down('2xl')]: {
      width: '544px',
    },
    [theme.breakpoints.down('xl')]: {
      width: '50%',
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      height: '344px',
    },
  },

  [theme.breakpoints.down('2xl')]: {
    padding: '32px',
  },
  [theme.breakpoints.down('xl')]: {
    width: '50%',
    padding: '24px',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '20px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '16px',
  },
}));

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '44px',

  [theme.breakpoints.down('2xl')]: {
    gap: '32px',
  },
  [theme.breakpoints.down('xl')]: {
    alignItems: 'center',
    textAlign: 'center',
    gap: '24px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '20px',
  },
}));

export const Avatars = styled('div')(() => ({
  display: 'flex',
  gap: '8px',
}));

export const Info = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  width: '100%',
  maxWidth: '666px',

  [theme.breakpoints.down('xl')]: {
    maxWidth: '100%',
  },
  [theme.breakpoints.down('md')]: {
    gap: '16px',
  },
}));

export const Title = styled(Typography)({});

export const Text = styled(Typography)({});

export const Download = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '12px',

  [theme.breakpoints.down('xl')]: {
    flexDirection: 'column',
    width: '100%',
  },
}));

export const DownloadBtn = styled('button')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '64px',
  padding: '0 44px',
  backgroundColor: theme.palette.color.button.primaryDefault,
  borderRadius: '120px',
  border: 'none',
  cursor: 'pointer',
  outline: 'none',
  transition: 'all 0.2s ease-in-out',
  willChange: 'transform',

  '&:hover': {
    backgroundColor: theme.palette.color.button.primaryHover,
  },
  '&:active': {
    transform: 'scale(0.95)',
  },

  [theme.breakpoints.down('2xl')]: {
    height: '54px',
  },
  [theme.breakpoints.down('xl')]: {
    width: '100%',
    padding: '0 30px',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const DownloadImg = styled('img')(({ theme }) => ({
  width: 'auto',
  height: '36px',

  [theme.breakpoints.down('xl')]: {
    height: '32px',
  },
}));

export const DecorCircles = styled(motion.div)(({ theme }) => ({
  position: 'absolute',
  filter: 'blur(92px)',
  inset: 0,

  [theme.breakpoints.down('2xl')]: {
    top: '-80px',
  },
  [theme.breakpoints.down('xl')]: {
    top: 0,
  },
  [theme.breakpoints.down('lg')]: {
    top: '-60px',
  },
}));

export const DecorCircle = styled(motion.span)(({ theme }) => ({
  position: 'absolute',
  borderRadius: '100%',

  '&:first-of-type': {
    top: '260px',
    left: '-186px',
    width: '900px',
    height: '900px',
    backgroundColor: theme.palette.color.yellow,

    [theme.breakpoints.down('2xl')]: {
      left: '-136px',
    },
  },
  '&:last-of-type': {
    top: '220px',
    left: '132px',
    width: '712px',
    height: '712px',
    backgroundColor: theme.palette.color.orange,
  },
}));

export const DecorImg = styled('img')(({ theme }) => ({
  position: 'absolute',
  top: '66px',
  width: '556px',
  bottom: '-2px',

  [theme.breakpoints.down('2xl')]: {
    width: '494px',
  },
  [theme.breakpoints.down('xl')]: {
    top: 'auto',
    right: 'auto',
    bottom: '-2px',
    width: '394px',
  },
  [theme.breakpoints.down('lg')]: {
    top: '40px',
    right: '-30px',
    bottom: 'auto',
  },
  [theme.breakpoints.down('md')]: {
    top: '40px',
    right: '-80px',
  },
}));
